import request from '@/utils/request';

// 登录
export const doLogin = (data: any): any =>
  request({
    url: '/provider/auth/login',
    data: data
  })

// 获取用户信息
export const getUserInfo = (data: any): any =>
  request({
    url: '/routuan/userinfo',
    data: data
  })

// 获取oss 临时凭证
export const getOssToken = (data: any): any =>
  request({
    url: '/common/osstoken',
    data
  })

// 修改供应商密码
export const resetProviderPwd = (data: any): any =>
  request({
    url: '/provider/auth/providerChangePassWord',
    data
  })

  
  // 发送短信验证码
  export const authsendSmsCode = (data: any): any =>
  request({
    url: '/provider/auth/sendSmsCode',
    data: data
  })
  
  // 重置密码
  export const authreSetLoginPassword = (data: any): any =>
  request({
    url: '/provider/auth/resetPassword',
    data: data
  })
  // 验证供应商账号
  export const authvaliteProviderPhone = (data: any): any =>
  request({
    url: '/provider/auth/valiteProviderPhone',
    data: data
  })
  

  
// 银行列表
export const banklist = (data: any): any =>
request({
	url: '/provider/bank/list',
	data: data
})
  
// 结算账户-信息
export const settlementAccountinfo = (data: any): any =>
request({
	url: '/provider/settlementAccount/info',
	data: data
})
// 结算账户-发送验证码
export const settlementAccountsendCode = (data: any): any =>
request({
	url: '/provider/settlementAccount/sendCode',
	data: data
})
// 结算账户-修改
export const settlementAccountedit = (data: any): any =>
request({
	url: '/provider/settlementAccount/edit',
	data: data
})

// 银行列表(财务结算用的)
export const bankFinanceSettlelist = (data: any): any =>
request({
	url: '/provider/bankFinanceSettle/list',
	data: data
})